<template>
<div>
    <b-container fluid class="md-content">
        <!-- <div class="md-header">Autom. Dienstplan erstellen</div> -->
        <b-card>
        <!-- STAGE 1: POSITIONEN-->
        <section v-if="state === 1">
           <h3 class="md-header">Positionen</h3>
            <b-row>
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="spotOptions" :fields="spotFields">
                        <template slot="checked" slot-scope="row">
                            <b-form-checkbox v-model="row.item.checked">
                            </b-form-checkbox>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-button variant="success" @click="confirmStage1()">Ok</b-button>
                </b-col>
            </b-row>
            <b-row v-if="error">
                <b-col>
                    {{errorMsg}}
                </b-col>
            </b-row>
        </section>
         <!-- STAGE 2: EMPLOYEES-->
        <section v-if="state === 2">
            <h3 class="md-header">Mitarbeiter</h3>
            <b-row>
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="employeeOptions" :fields="employeeFields">
                        <!-- <template slot="checked" slot-scope="row">
                            <b-form-checkbox v-model="row.item.checked">
                            </b-form-checkbox>
                        </template> -->
                    </b-table>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="warning" @click="abortStage()">Zurück</b-button>
                </b-col>
                <b-col>
                    <b-button variant="success" @click="confirmStage2()">Ok</b-button>
                </b-col>
            </b-row>
            <b-row v-if="error">
                <b-col>
                    {{errorMsg}}
                </b-col>
            </b-row>
        </section>
        <!-- STAGE 4: Verfügbarkeiten-->
        <section v-if="state === 3">
            <h3 class="md-header">Mitarbeiter Verfügbarkeiten</h3>
            <b-row>
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="employeeAvailabilityOptions" :fields="employeeAvailabilityFields">
                        <template slot="stateLabel" slot-scope="row">
                            <p v-if="employeeAvailabilityStateMap[row.item.state] != null"> {{employeeAvailabilityStateMap[row.item.state].label_de}}</p>
                        </template>
                        <template slot="checked" slot-scope="row">
                            <b-form-checkbox v-model="row.item.checked">
                            </b-form-checkbox>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <h3 class="md-header">Mitarbeiter Präferenzen & Urlaube</h3>
            <b-row>
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="employeePreferenceOptions" :fields="employeePreferenceFields">
                        <template slot="stateLabel" slot-scope="row">
                            <p v-if="employeeAvailabilityStateMap[row.item.state] != null"> {{employeeAvailabilityStateMap[row.item.state].label_de}}</p>
                        </template>
                        <template slot="typeLabel" slot-scope="row">
                            <p v-if="row.item.type != null && employeeAvailabilityTypeMap[row.item.type] != null"> {{employeeAvailabilityTypeMap[row.item.type].label_de}}</p>
                        </template>
                        <template slot="checked" slot-scope="row">
                            <b-form-checkbox v-model="row.item.checked">
                            </b-form-checkbox>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col>
                    <b-button variant="warning" @click="abortStage()">Zurück</b-button>
                </b-col>
                <b-col>
                    <b-button variant="success" @click="confirmStage3()">Ok</b-button>
                </b-col>
            </b-row>
            <b-row v-if="error">
                <b-col>
                    {{errorMsg}}
                </b-col>
            </b-row>
        </section>
        <!-- STAGE 5: SHIFTS-->
        <section v-if="state === 4">
            <h3 class="md-header">Schichten: {{selectedShifts.length}}</h3>
            <b-card no-body class="mb-1" v-bind:key="accordionEntry.id" v-for="accordionEntry in planshiftWeekAccordionEntries">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block href="#" v-b-toggle="accordionEntry.id" style="background-color: #6d8d21">{{accordionEntry.id}}</b-button>
                </b-card-header>
                <b-collapse :id="accordionEntry.id" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-table striped hover :borderless="true" :outlined="false" :items="accordionEntry.entries" :fields="shiftFields">
                            <template slot="checked" slot-scope="row">
                                <b-form-checkbox v-model="row.item.checked">
                                </b-form-checkbox>
                            </template>
                        </b-table> 
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!--<b-row>
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="shiftOptions" :fields="shiftFields">
                        <template slot="checked" slot-scope="row">
                            <b-form-checkbox v-model="row.item.checked">
                            </b-form-checkbox>
                        </template>
                    </b-table>
                </b-col>
            </b-row>-->
            <h3 class="md-header">Nicht besetzbare Schichten: {{impossibleShiftOptions.length}}</h3>
            <b-row>
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="impossibleShiftOptions" :fields="impossibleShiftFields">
                        
                    </b-table>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="warning" @click="abortStage()">Zurück</b-button>
                </b-col>
                <b-col>
                    <b-button variant="success" @click="confirmStage4()">Ok</b-button>
                </b-col>
            </b-row>
            <b-row v-if="error">
                <b-col>
                    {{errorMsg}}
                </b-col>
            </b-row>
        </section>
       
        
        
        <!-- STAGE 6: Regeln auswählen + Planzeit-->
        <section v-if="state === 5">
            <h3 class="md-header">Plan-Einstellungen</h3>

            <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Plan Profil" label-for="rprofile">
                    <b-form-select id = "rprofile" v-model="ruleProfile">
                        <option v-for="option in ruleProfiles" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.labelDe }}
                        </option>
                    </b-form-select>
            </b-form-group>
             <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="High Performance" label-for="cer8">
                <b-form-checkbox id="highperf" v-model="hp">
                </b-form-checkbox>
            </b-form-group>
            <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Plan-Laufzeit" label-for="cer8" :description="planRunTime+' Minuten'">
                <b-form-input min="5" max="60" id="cer8" v-model.number="planRunTime" type="range"></b-form-input>
            </b-form-group>
            
            <b-row>
                <b-col>
                    <b-button variant="warning" @click="abortStage()">Zurück</b-button>
                </b-col>
                <b-col>
                    <b-button variant="success" @click="confirmStage5()">Ok</b-button>
                </b-col>
            </b-row>   
            <b-row v-if="error">
                <b-col>
                    {{errorMsg}}
                </b-col>
            </b-row>
        </section>
        </b-card>
    </b-container>

  </div>

</template>

<script>
import VueEventBus from '../../vue-event-bus';
const moment = require('moment');
export default {
  name: 'rosterrequestwizard',
  data () {
    return {
      uiData: {},
      employeeAvailabilityStateMap: {},
      employeeAvailabilityTypeMap: {},
      bunitOptions: [],
      selectedBunits: [],
      bunitFields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key: "checked", thClass: 'documentsTh', tdClass: 'documentsTd', label: "Ausgewählt"}], 
      bunitMap: {},
      //#######
      spotOptions: [],
      selectedSpots: [],
      spotFields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"bunitName", label:"Bereich", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key: "checked", thClass: 'documentsTh', tdClass: 'documentsTd', label: "Ausgewählt"}], 
      spotMap: {},
      //#######
      shiftOptions: [],
      impossibleShiftOptions: [],
      shiftFields: [{key:"spot", label:"Position", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"employee", label:"Mitarbeiter", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, 
                   {key:"from", label:"Von", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},{key:"to", label:"Bis", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key: "checked", thClass: 'documentsTh', tdClass: 'documentsTd', label: "Ausgewählt"}],
      impossibleShiftFields: [{key:"spot", label:"Position", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"employee", label:"Mitarbeiter", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, 
                   {key:"from", label:"Von", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},{key:"to", label:"Bis", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}],
      shiftMap: {},
      //#######
      skillMap: {},
      shiftSkillMap:{},
      //#######
      employeeOptions: [],
      //employeeFields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key: "checked", label: "Ausgewählt"}], 
      employeeFields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}],
      employeeMap: {},
      //#######
      employeeAvailabilityOptions: [],
      employeeAvailabilityFields: [{key:"spot", label:"Position", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"employee", label:"Mitarbeiter", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, 
                   {key:"from", label:"Von", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},{key:"to", label:"Bis", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"stateLabel", label:"Status", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, 
                   {key: "weekdays", thClass: 'documentsTh', tdClass: 'documentsTd', label: "Wochentage"}, {key: "checked", thClass: 'documentsTh', tdClass: 'documentsTd', label: "Ausgewählt"}],
      employeeAvailabilityMap: {},
      //#######
      employeePreferenceOptions: [],
      employeePreferenceFields: [{key:"spot", label:"Position", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"employee", label:"Mitarbeiter", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, 
                   {key:"from", label:"Von", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},{key:"to", label:"Bis", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"stateLabel", label:"Status", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},
                   {key:"typeLabel", label:"Typ", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key: "checked", thClass: 'documentsTh', tdClass: 'documentsTd', label: "Ausgewählt"}],
      fullWeekPlanFrom: null,
      fullWeekPlanTo: null,
      employeePreferenceMap: {},
      //#######
      employeeContractMap: {},
      //#######
      employeeSkillMap: {},
      employeeTypeMap: {},
      employeeRulesMap: {},
      spotPayload: {ids: []},
      employeePayload: {ids: []},
      state: 0,
      ruleProfileMap: {},
      ruleProfiles: [],
      ruleProfile: 1,
      hp: false,
      rosterConfiguration: {
          dayIndexStart: 1,
          dayIndexEnd: 1,
          month: 1,
          year: 2019,
          additionalWeeks: 0,
          additionalWorkDays: [],
          //rules that should always be enabled
          rules: {"1": 1, "5": 1, "6": 1, "7": 1, "8": 1, "19": 1, "20": 1},
          rulesSoftScoreLevels: {}

      },
      planRunTime: 5,
      error: false,
      errorMsg: ""
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        let view = this;
        this.loadUIData()
        .then(response => {
            view.updateUIData(response.data);
            return view.loadBusinessUnits();
        }).then(response => {
            
            let bunitMap =  {};
            for (let i = 0; i < response.data.length; i++) {
                bunitMap[response.data[i].id] = response.data[i]; 
            }
            view.bunitMap = bunitMap;
            view.error = false;
            view.state = 1;
            return view.loadSkills(); 
        }).then(response => {
            var i;
            let skillMap = {};
            for (i = 0; i < response.data.length; i++) {
                skillMap[response.data[i].id] = response.data[i];    
            }
            view.skillMap = skillMap;
            return  view.loadSpots();
        })
        .then(response => {

            let spotOptions = [];
            let spotMap = {};
            for (let i = 0; i < response.data.length; i++) {
                spotMap[response.data[i].id] = response.data[i];
                let tOption = { id: response.data[i].id, name: response.data[i].name, bunitName: view.bunitMap[response.data[i].unitId].name , value: response.data[i], checked: true }
                spotOptions.push(tOption);     
            }
            view.spotOptions = spotOptions;
            view.spotMap = spotMap;
            view.error = false;
            view.state = 1; 
        }).catch(error => {
            view.error = true;
            if(error.msg != null){
                view.errorMsg = error.msg;
            } else {
                console.log(error);
                view.errorMsg = "Fehler beim Laden der Daten für Schritt 1!"
            }
        })
         
    }
  }, 
  computed: {
        rosterResultFromTo() {
            if(this.$store.state.loggedIn){
                return this.$store.state.rosterFromTo;
            } else {
                return null;
            }    
        },
        planshiftWeekAccordionEntries(){
            let accordionEntries = { }
            this.shiftOptions.forEach(option => {
                let weekId = 'KW '+option.week+' - '+option.year;
                if(!accordionEntries[weekId]){
                    accordionEntries[weekId] = [];
                }
                accordionEntries[weekId].push(option);
            })
            
            return Object.keys(accordionEntries).map(key => {
                return {id: key, entries: accordionEntries[key]};
            });
            
        },
        selectedShifts(){
            return this.planshiftWeekAccordionEntries.map(e => e.entries).reduce((a, b) => a.concat(b), []).filter(e => e.checked).map(e => e.id);
        }
  },
  
  watch: { 
   

  },
  // methods that implement data logic.
  methods: {
    abortStage: function(){
        this.state = this.state-1;
    },
    loadBusinessUnits : function() {
      let view = this;
      let url = '/api/sec/businessunit';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/businessunit');
      

      return this.axios({
        method: 'get',
        headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
        url: url
      });
        
        
    },
    confirmStage1: function() {
        let selectedMonth = this.$store.state.rosterFromTo.month;
        let startDate = this.$helpers.getCurrentMonthMomentUTC().month(selectedMonth);
        let endDate = startDate.clone().endOf('month');

        console.log(startDate.format());
        console.log(endDate.format());
      
       if (this.spotOptions.filter(i => i.checked === true).length < 1 ){
            this.error = true;
            this.errorMsg = "Bitte wählen Sie mindestens eine Position aus!"
        } else {
            
            // DO NOT TOUCH DATE + WORKDAY INDEX CALCULATION UNLESS YOU KNOW WHAT YOU ARE DOING
            this.rosterConfiguration.dayIndexStart = startDate.date();
            this.rosterConfiguration.dayIndexEnd = endDate.date();
            this.rosterConfiguration.month = startDate.month()+1;
            this.rosterConfiguration.year = startDate.year();

            this.fullWeekPlanFrom = startDate.clone().startOf('isoWeek');
            this.fullWeekPlanTo = endDate.clone().endOf('isoWeek').add(1,'weeks').startOf('isoWeek');

            console.log(this.fullWeekPlanFrom.format());
            console.log(this.fullWeekPlanTo.format());
            
            let tempWeekStart = this.fullWeekPlanFrom.clone();
            let targetIndexDelta = this.calculateWorkDayIndex(startDate)-1;
            let indexDelta = this.calculateWorkDayIndex(tempWeekStart)-1;

            
            while(indexDelta != targetIndexDelta){
                this.rosterConfiguration.additionalWorkDays.push(indexDelta);
                tempWeekStart = tempWeekStart.add(1,'days');
                indexDelta = this.calculateWorkDayIndex(tempWeekStart)-1;
            } 
            
            let tempWeekEnd = this.fullWeekPlanTo.clone();
            targetIndexDelta = this.calculateWorkDayIndex(endDate)-1;
            indexDelta = this.calculateWorkDayIndex(tempWeekEnd)-1;
           
            while(indexDelta !== targetIndexDelta){
                this.rosterConfiguration.additionalWorkDays.push(indexDelta);
                tempWeekEnd = tempWeekEnd.subtract(1,'days');
                indexDelta = this.calculateWorkDayIndex(tempWeekEnd)-1;
            }
            console.log(JSON.stringify(this.rosterConfiguration.additionalWorkDays));
            this.selectedSpots = [];
            let spotPayload = { ids: []};
            let spotSkillPayload = {ids: []};
            for (let i = 0; i < this.spotOptions.length; i++) {
                if(this.spotOptions[i].checked){
                    this.selectedSpots.push(this.spotOptions[i].id);
                    spotPayload.ids.push(this.spotOptions[i].id);
                    spotSkillPayload.ids.push(this.spotMap[this.spotOptions[i].id].requiredSkill);
                }
                
            }
            this.spotPayload = spotPayload;
            this.error = false;
            this.prepareStage2(spotSkillPayload);
        }
    },
    prepareStage2: function(payload) {
        let view = this;
        let rulepayload = {ids: []};
        let typepayload =  {ids: []};
        
        this.loadEmployeesAnySkill(payload)
        .then(response => {
            
            let employeeMap = {}
            let employeeOptions = [];
            var i;
            let employeePayload = {ids:[]};
            for (i = 0; i < response.data.length; i++) {
                
                if(response.data[i].typeId != null && response.data[i].ruleId != null){
                    
                    let tOption = { id: response.data[i].id, name: response.data[i].firstName + " " + response.data[i].lastName, typeId: response.data[i].typeId, ruleId: response.data[i].ruleId, checked: true }
                    employeeOptions.push(tOption);
                    employeePayload.ids.push(response.data[i].id);
                    employeeMap[response.data[i].id] = response.data[i];
                    if(!typepayload.ids.includes(response.data[i].typeId)){
                        typepayload.ids.push(response.data[i].typeId);
                    }
                    if(!rulepayload.ids.includes(response.data[i].ruleId)){
                        rulepayload.ids.push(response.data[i].ruleId);
                    }
                }
               
            }

            view.employeeOptions = employeeOptions;
            view.employeeMap = employeeMap;
            view.employeePayload = employeePayload;
            view.error = false;

            return this.loadEmployeeSkillsAnyEmployee(view.employeePayload);
            
        }).then(response => {
            var i;
            let employeeSkillMap = {};
            for (i = 0; i < response.data.length; i++) { 
                let skillId = response.data[i].skillId;
                let employeeId = response.data[i].employeeId;
                let value = response.data[i].value;
                if(!employeeSkillMap[employeeId]){
                    employeeSkillMap[employeeId] = {};
                   
                }
                employeeSkillMap[employeeId][skillId] = {skillId: skillId, value: value};
            }
            view.employeeSkillMap = employeeSkillMap;
            //Remember: employee skill id might not be in skillMap because skill is not required => skip when creating request payload
            return this.loadEmployeeRulesAny(rulepayload);
        }).then(response => {
            var i;
            let employeeRulesMap = {};
            for (i = 0; i < response.data.length; i++) { 
                employeeRulesMap[response.data[i].id] = response.data[i];
            }
            view.employeeRulesMap = employeeRulesMap;

            return this.loadEmployeeTypeAny(typepayload)
        }).then(response => {
            var i;
            let employeeTypeMap = {};
            for (i = 0; i < response.data.length; i++) { 
                 employeeTypeMap[response.data[i].id] = response.data[i];
            }
            view.employeeTypeMap = employeeTypeMap;
            view.state = 2;
        }).catch(error => {
            view.error = true;
            if(error.msg != null){
                view.errorMsg = error.msg;
            } else {
                console.log(error);
                view.errorMsg = "Fehler beim Laden der Daten für Schritt 3!"
            }
        })
        
    },
    confirmStage2: function() {
        if (this.employeeOptions.filter(i => i.checked === true).length < 1 ){
            this.error = true;
            this.errorMsg = "Es muss mindestens ein Mitarbeiter planbar sein!"
        } else {
            
            this.prepareStage3(this.employeePayload);
        }
       
        
    },
    prepareStage3: function(employeepayload) {
        let view = this;
        view.loadEmployeeAvailabilityAnyEmployee(employeepayload)
        
        .then(response => {
            let availabilityOptions = []
            var i;
            var j;
            let weekDaysArray = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
            for (i = 0; i < response.data.length; i++) {
                let weekdays = "";
                for (j = 0; j < response.data[i].weekDays.length; j++) {
                    weekdays +=weekDaysArray[response.data[i].weekDays[j]-1]+", "
                }
                if(weekdays.length > 2){
                    weekdays = weekdays.slice(0, -2);
                }
                let position = "";
                if(response.data[i].spotId != null){
                    position = view.spotMap[response.data[i].spotId].name;
                }
                let employee = "";
                if(response.data[i].employeeId != null){
                    employee = view.employeeMap[response.data[i].employeeId].firstName+" "+view.employeeMap[response.data[i].employeeId].lastName;
                }
               
                let tOption = { id: response.data[i].id, state: response.data[i].state, from: response.data[i].from, to: response.data[i].to, 
                                employee: employee, spot: position, type: response.data[i].type, weekdays: weekdays, value: response.data[i], checked: true }
                availabilityOptions.push(tOption);
            }
            view.employeeAvailabilityOptions = availabilityOptions;
            return view.loadEmployeePreferenceAnyEmployee(employeepayload);
        }).then(response => {
            let preferenceOptions = []
            var i;
            for (i = 0; i < response.data.length; i++) {

                let position = "";
                if(response.data[i].spotId != null){
                    position = view.spotMap[response.data[i].spotId].name;
                }
                let employee = "";
                if(response.data[i].employeeId != null){
                    employee = view.employeeMap[response.data[i].employeeId].firstName+" "+view.employeeMap[response.data[i].employeeId].lastName;
                }

                let tOption = { id: response.data[i].id, state: response.data[i].state, type: response.data[i].type, workValue: response.data[i].workValue,
                                from: view.$helpers.getMomentFromStringUTC(response.data[i].from).format("DD.MM.YYYY HH:mm"), 
                                to: view.$helpers.getMomentFromStringUTC(response.data[i].to).format("DD.MM.YYYY HH:mm"), 
                                employee: employee, spot: position, type: response.data[i].type, value: response.data[i], checked: true }
                preferenceOptions.push(tOption);
            }
            view.employeePreferenceOptions = preferenceOptions;
            return view.loadEmployeeContractsAnyEmployee(employeepayload);
        }).then(response => {
            view.employeeContractMap = {};
            for (let i= 0; i < response.data.length; i++) {
                let contract = response.data[i];
                if(view.employeeContractMap[contract.employeeId] == null){
                    view.employeeContractMap[contract.employeeId] = []
                }
                view.employeeContractMap[contract.employeeId].push(contract);
            }
            
            view.checkMissingContractIntervals(employeepayload.ids);
            view.state = 3; 
        }).catch(error => {
            view.error = true;
            if(error.msg != null){
                view.errorMsg = error.msg;
            } else {
                console.log(error);
                view.errorMsg = "Fehler beim Laden der Daten für Schritt 5!"
            }
        })
        
    },
    confirmStage3: function() {
        
            
        this.employeeAvailabilityMap = {}
          
        var i;
        for (i = 0; i < this.employeeAvailabilityOptions.length; i++) { 
            if(this.employeeAvailabilityOptions[i].checked){
                if(this.employeeAvailabilityMap[this.employeeAvailabilityOptions[i].value.employeeId] != null){
                    this.employeeAvailabilityMap[this.employeeAvailabilityOptions[i].value.employeeId].push(this.employeeAvailabilityOptions[i].value)
                } else {
                    this.employeeAvailabilityMap[this.employeeAvailabilityOptions[i].value.employeeId] = [];
                    this.employeeAvailabilityMap[this.employeeAvailabilityOptions[i].value.employeeId].push(this.employeeAvailabilityOptions[i].value)
                }
            }
                
        }
        for (i = 0; i < this.employeePreferenceOptions.length; i++) { 
            if(this.employeePreferenceOptions[i].checked){
                if(this.employeePreferenceMap[this.employeePreferenceOptions[i].value.employeeId] != null){
                    this.employeePreferenceMap[this.employeePreferenceOptions[i].value.employeeId].push(this.employeePreferenceOptions[i].value)
                } else {
                    this.employeePreferenceMap[this.employeePreferenceOptions[i].value.employeeId] = [];
                    this.employeePreferenceMap[this.employeePreferenceOptions[i].value.employeeId].push(this.employeePreferenceOptions[i].value)
                }
            }
        }
            
       
        this.prepareStage4(this.spotPayload, this.employeePayload);
        
    },
    prepareStage4: function(spotPayload, employeePayload) {
        let view = this;
        
        
        let tShifts;
        this.loadShiftsAnySpotAnyEmployee(spotPayload, employeePayload).then(response => {
            let shiftMap = {}
            let shiftPayload = {ids:[]};
            tShifts = response.data;
            for (let i = 0; i < response.data.length; i++) {
                shiftPayload.ids.push(response.data[i].id);
                shiftMap[response.data[i].id] = response.data[i];
            }

           
            view.shiftMap = shiftMap;
            return this.loadShiftSkillsAnyShift(shiftPayload);
        })
        .then(response => {
            
            this.shiftSkillMap = {};
            for (let i = 0; i < response.data.length; i++) { 
                let skillId = response.data[i].skillId;
                let shiftId = response.data[i].shiftId;
                if(!this.shiftSkillMap[shiftId]){
                    this.shiftSkillMap[shiftId] = []
                }
                this.shiftSkillMap[shiftId].push({skillId: skillId, required: response.data[i].required, minValue: response.data[i].minValue, maxValue: response.data[i].maxValue})
                
            }
            let shiftOptions = [];
            let impossibleShiftOptions = [];
            for (let i = 0; i < tShifts.length; i++) {
                let tShift = tShifts[i];
                
                let position = "";

                if(tShift.spotId != null){
                    position = view.spotMap[tShift.spotId].name;
                }
                let employee = "";
                if(tShift.employeeId != null){
                    if(view.employeeMap[tShift.employeeId] == null){
                        employee = "Ungültiger Mitarbeiter"
                    } else {
                        employee = view.employeeMap[tShift.employeeId].firstName+" "+view.employeeMap[tShift.employeeId].lastName;
                    }
                    
                }
                if(view.selectedSpots.includes(tShift.spotId)){
                    let fromMoment = this.$helpers.getMomentFromStringUTC(tShift.from);
                    let tOption = { id: tShift.id, spot: position, employee: employee, from: fromMoment.format("DD.MM.YYYY HH:mm"), 
                                    to: this.$helpers.getMomentFromStringUTC(tShift.to).format("DD.MM.YYYY HH:mm"), week: fromMoment.isoWeek(),
                                    year: fromMoment.isoWeekYear(),
                                    checked: true };
                    
                    let shiftIsPossible = false;
                    for(let employeeId in this.employeeMap){
                        if(this.checkEmployeeCanDoShift(employeeId, tShift.id, tShift.spotId)){
                            shiftIsPossible = true;
                            break;
                        }
                    }
                    if(shiftIsPossible){
                        shiftOptions.push(tOption);
                    } else {
                        impossibleShiftOptions.push(tOption);
                    }
                    
                } 
            }

            view.shiftOptions = shiftOptions;
            view.impossibleShiftOptions = impossibleShiftOptions;
            view.state = 4;
        }).catch(error => {
            view.error = true;
            if(error.msg != null){
                view.errorMsg = error.msg;
            } else {
                console.log(error);
                view.errorMsg = "Fehler beim Laden der Daten für Schritt 5!"
            }
        })
        
    },
    checkEmployeeCanDoShift(employeeId, shiftId, spotId) {
        let hasSpotSkill = this.employeeSkillMap[employeeId] && this.spotMap[spotId] && this.employeeSkillMap[employeeId][this.spotMap[spotId].requiredSkill]
        let hasRequiredSkills = true;
        if(this.shiftSkillMap[shiftId]){
             for(let i = 0; i < this.shiftSkillMap[shiftId].length;i++){
                let shiftSkill = this.shiftSkillMap[shiftId][i];
                if(shiftSkill.required){
                    let employeeHasSkill = this.employeeSkillMap[employeeId] && 
                                           this.employeeSkillMap[employeeId][shiftSkill.skillId] && 
                                           this.employeeSkillMap[employeeId][shiftSkill.skillId].value <= shiftSkill.maxValue &&
                                           this.employeeSkillMap[employeeId][shiftSkill.skillId].value >= shiftSkill.minValue;
                    if(!employeeHasSkill){
                        hasRequiredSkills = false;
                        break;
                    }
                }
             }
        }
        return hasSpotSkill && hasRequiredSkills;
    },
    confirmStage4: function() {
        if (this.shiftOptions.filter(i => i.checked === true).length < 1){
            this.error = true;
            this.errorMsg = "Bitte wählen Sie mindestens eine Schicht aus!"
        } else {
            
           
            this.error = false;
            this.prepareStage5();
        }
    },
    
    prepareStage5: function() {
        let view = this;
        this.loadRuleProfiles()
        .then(response=> {
            view.ruleProfileMap = {};
            for(let i = 0; i<response.data.length; i++){
                view.ruleProfileMap[response.data[i].id] = response.data[i];
            }
            view.ruleProfiles = response.data;
            view.state = 5;
        })
        .catch(error => {
            view.error = true;
            if(error.msg != null){
                view.errorMsg = error.msg;
            } else {
                console.log(error);
                view.errorMsg = "Fehler beim Laden der Daten für Schritt 6!"
            }
        })
        
    },
    confirmStage5: function(){
        let view = this;
        let payload = this.buildAutoSchedulerRequest(this.spotMap, this.skillMap, this.shiftMap, this.shiftSkillMap, this.employeeMap, 
                                           this.employeeRulesMap, this.employeeSkillMap, this.employeeTypeMap, this.employeeAvailabilityMap, this.employeePreferenceMap, this.employeeGroupMap);
        
        this.submitRosterRequest(payload)
        .then(response => {
            VueEventBus.$emit('autoscheduling-submitted', {});
        }).catch(error => {
            view.error = true;
            if(error.msg != null){
                view.errorMsg = error.msg;
            } else {
                console.log(error);
                view.errorMsg = "Fehler beim Schicken des Plan-Requests!"
            }
        })

    },
    buildAutoSchedulerRequest: function(spotMap, skillMap, shiftMap, shiftSkillMap, employeeMap, employeeRulesMap, employeeSkillMap, employeeTypeMap, employeeAvailabilityMap, employeePreferenceMap, groupMap){
        //DONT TOUCH UNLESS YOU KNOW WHAT YOU ARE DOING
        let customEntityMapping = {};
        let spotMapping = {}, employeeMapping = {}, skillMapping = {}, shiftMapping = {}, typeMapping = {};
        let requestSpotMap = {}, requestEmployeeMap = {}, requestSkillMap = {}, requestShiftMap = {}, requestTypeMap = {}, requestPreferenceMap = {};
        let spotRequestId =1, employeeRequestId = 1, skillRequestId=1, shiftRequestId = 1, typeRequestId = 1, preferenceRequestId = 1;
        //build request skillMap
        customEntityMapping.skillMapping = {}
        let key =null;
        for (key in skillMap) {
            if (skillMap.hasOwnProperty(key)) {
                let skill = skillMap[key];
                let requestkey = ""+skillRequestId;
                skillMapping[skill.id] = skillRequestId;
                let requestSkill = {id: skillRequestId, name: skill.name}
                requestSkillMap[requestkey] = requestSkill;
                customEntityMapping.skillMapping[requestkey] = {originalId: skill.id, hash: skill.hash};
                skillRequestId++;
            }
        }
        //build request spotMap
        customEntityMapping.spotMapping = {};
        for (key in spotMap) {
            if (spotMap.hasOwnProperty(key)) {
                let spot = spotMap[key];
                let requestkey = ""+spotRequestId;
                spotMapping[spot.id] = spotRequestId;
                let requestSpot = {id: spotRequestId, name: spot.name}
                if(spot.requiredSkill != null && skillMapping[spot.requiredSkill] != null){
                    requestSpot.requiredSkillId = skillMapping[spot.requiredSkill];
                }
                requestSpotMap[requestkey] = requestSpot;
                customEntityMapping.spotMapping[requestkey] = {originalId: spot.id, hash: null};
                spotRequestId++;
            }
        }
        //build request employeeTypeMap with rules
        //flag for enabling double sunday rule
        let doubleSundayRule = false;
       
        //build request employeeMap and employeeTypeMap
        customEntityMapping.employeeMapping = {}
        var j;
        for (key in employeeMap) {
            if (employeeMap.hasOwnProperty(key)) {
                let employee = employeeMap[key];
                //console.log(JSON.stringify(employee));
                if(!this.$helpers.isBlank(employee.ruleId) && !this.$helpers.isBlank(employeeRulesMap[employee.ruleId]) && !this.$helpers.isBlank(employee.typeId) && !this.$helpers.isBlank(employeeTypeMap[employee.typeId])){
                   
                        let employeeType = employeeTypeMap[employee.typeId];
                        let requestkey = ""+typeRequestId;
                        
                        let requestType = {id: typeRequestId, name: "", 
                                        monthTimeRegular: employeeType.monthTimeRegular,
                                        dayTimeMax: employeeType.dayTimeMax,
                                        dayTimeRegular: employeeType.dayTimeRegular,
                                        daysConsecutiveMax: employeeType.daysConsecutiveMax,
                                        interDayBetweenTimeMin: employeeType.restTime,
                                        monthOvertimeMax: employeeType.monthOvertimeMax,
                                        overtimeCutoff: employeeType.overtimeCutoff,
                                        rules: {}, rulesScaling: {}}
                        if(requestType.daysConsecutiveMax > -1){
                            this.rosterConfiguration.rules["2"] = 1;
                        }
                        if(requestType.monthOvertimeMax > -1){
                            this.rosterConfiguration.rules["3"] = 1;
                        }
                        if(employeeType.shiftBetweenTimeMin > -1){
                            requestType.betweenTimeMin = employeeType.shiftBetweenTimeMin;
                            requestType.intraDayBetweenMax = employeeType.shiftBetweenTimeMax;
                        } else {
                            requestType.betweenTimeMin = employeeType.restTime;
                            requestType.intraDayBetweenMax = -1;
                        }

                        if(employeeType.monthTimeMaxType === 2){
                            requestType.monthTimeMax = employeeType.monthTimeRegular + employeeType.monthTimeMaxAdjustment;
                            requestType.rules["7"] = 1;
                        } else if (employeeType.monthTimeMaxType === 3){
                            requestType.monthTimeMax = employeeType.monthTimeRegular;
                            requestType.rules["7"] = 1;
                        } else {
                            requestType.monthTimeMax = -1;
                        }

                        if(employeeType.weekTimeAvgType === 2){
                             requestType.rules["29"] = 1;
                             this.rosterConfiguration.rules["29"] = 1;
                        }
                        if(employeeType.weekTimeAvgType === 3){
                             requestType.rules["30"] = 1;
                             this.rosterConfiguration.rules["30"] = 1;
                        }

                        requestType.defaulWeeklyParams = {
                            weekTimeMax: employeeType.weekTimeMax,
                            weekTimeRegular: employeeType.weekTimeRegular,
                            weekWorkDaysMax: employeeType.weekWorkDaysMax,
                            weekWorkDaysRegular: employeeType.weekWorkDaysRegular,
                            weekSpareTimeMin: employeeType.weekSpareTimeMin,
                            weekSpareDaysMin: employeeType.weekSpareDaysMin
                        }
                        if(requestType.defaulWeeklyParams.weekWorkDaysMax > -1){
                            this.rosterConfiguration.rules["4"] = 1;
                        }
                        if(employeeType.weekSpareTimeStartType == 2 && !this.$helpers.isBlank(employeeType.weekSpareTimeStart)){
                            requestType.defaulWeeklyParams.spareTimeStartRegular = employeeType.weekSpareTimeStart;
                            requestType.rules["31"] = 1;
                            this.rosterConfiguration.rules["31"] = 1;
                        } else if(employeeType.weekSpareTimeStartType == 3 && !this.$helpers.isBlank(employeeType.weekSpareTimeStart)){
                            requestType.defaulWeeklyParams.spareTimeStartRegular = employeeType.weekSpareTimeStart;
                            requestType.defaulWeeklyParams.spareTimeStartRequired = employeeType.weekSpareTimeStart;
                            requestType.rules["31"] = 1;
                            this.rosterConfiguration.rules["31"] = 1;
                        }
                    
                        
                        let employeeRules = employeeRulesMap[employee.ruleId];
                        if(employeeRules.rules["desiredR"] != undefined && employeeRules.rules["desiredR"] > 0){
                            requestType.rules["9"] = employeeRules.rules["desiredR"];
                            this.rosterConfiguration.rules["9"] = 1;
                        }
                        if(employeeRules.rules["undesiredR"] != undefined && employeeRules.rules["undesiredR"] > 0){
                            requestType.rules["10"] = employeeRules.rules["undesiredR"];
                            this.rosterConfiguration.rules["10"] = 1;
                        }
                        if(employeeRules.rules["weekendR"] != undefined && employeeRules.rules["weekendR"] > 0){
                            requestType.rules["12"] = employeeRules.rules["weekendR"];
                            this.rosterConfiguration.rules["12"] = 1;
                        }
                        if(employeeRules.rules["weekendDaysR"] != undefined && employeeRules.rules["weekendDaysR"] > 0){
                            requestType.rules["13"] = employeeRules.rules["weekendDaysR"];
                            this.rosterConfiguration.rules["13"] = 1;
                        }
                        if(employeeRules.rules["skillR"] != undefined && employeeRules.rules["skillR"] > 0){
                            requestType.rules["15"] = employeeRules.rules["skillR"];
                            this.rosterConfiguration.rules["15"] = 1;
                        }
                        if(employeeRules.rules["fairnessDefinitionR"] != undefined && employeeRules.rules["fairnessDefinitionR"] > 0){
                            requestType.rules["16"] = employeeRules.rules["fairnessDefinitionR"];
                            this.rosterConfiguration.rules["16"] = 1;
                        }
                        if(employeeRules.rules["bioR"] != undefined && employeeRules.rules["bioR"] > 0){
                            requestType.rules["24"] = employeeRules.rules["bioR"];
                            this.rosterConfiguration.rules["24"] = 1;
                        }
                        
                        
                       
                        //check birthdate of employee, if hes underage activate double sunday rule
                        let age = Math.floor((new Date() - new Date(employee.dob+'Z').getTime()) / 3.15576e+10)
                        if(age < 18){
                            requestType.rules["20"] = 1
                            this.rosterConfiguration.rules["20"] = 1;
                        }
                        
                        requestTypeMap[requestkey] = requestType;
                        
                        requestkey = ""+employeeRequestId;
                        employeeMapping[employee.id] = employeeRequestId;
                        let requestEmployee = {id: employeeRequestId, 
                                            name: employee.firstName + employee.lastName,
                                            typeId: requestType.id, 
                                            skillProficiencyMap: {}}
                        if(employeeSkillMap[key] != undefined){
                            for (let skillId in employeeSkillMap[key]) { 
                                if(skillMapping[skillId] != null){ //check if skill id was ever put in skillMapping and therefore has request id
                                    requestEmployee.skillProficiencyMap[""+skillMapping[skillId]] = { skillId: skillMapping[skillId], value: employeeSkillMap[key][skillId].value};
                                } 
                            }
                        }
                        
                        requestEmployeeMap[requestkey] = requestEmployee;
                        customEntityMapping.employeeMapping[requestkey] = {originalId: employee.id, hash: employee.hash};
                        employeeRequestId++;
                        typeRequestId++;
                    
                }
                
            }
        }
        //build request timeSlotDefinitions Map
        customEntityMapping.shiftMapping = {}
        for (key in shiftMap) {
            if (shiftMap.hasOwnProperty(key)) {
                let shift = shiftMap[key];
                let requestkey = ""+shiftRequestId;
                shiftMapping[shift.id] = shiftRequestId;
                let shiftStartDate = this.$helpers.getMomentFromStringUTC(shift.from);
                let workDayIndex = this.calculateWorkDayIndex(shiftStartDate);
                let shiftEndDate = this.$helpers.getMomentFromStringUTC(shift.to);
               
                let workValue = 0;
                if(shift.workValue === -1){
                    workValue =  shiftEndDate.diff(shiftStartDate, 'minutes');
                } else {
                    workValue = shift.workValue
                }
                let requestTimeSlot = {id: shiftRequestId, 
                                       fromH: shiftStartDate.hours(),
                                       fromM: shiftStartDate.minutes(),
                                       toH: shiftEndDate.hours(),
                                       toM: shiftEndDate.minutes(), 
                                       workValue: workValue,
                                       count: 1,
                                       locked: false, 
                                       requiredSkills: {}, optionalSkills: []}
                if(shift.spotId != null && spotMapping[shift.spotId] != undefined){
                    requestTimeSlot.spotId = spotMapping[shift.spotId];
                }
                let isPreviousMonthShift = shiftStartDate.month()+1 == this.rosterConfiguration.month-1;
                if(shift.employeeId != null && employeeMapping[shift.employeeId] != undefined && (shift.pinned || shift.published || isPreviousMonthShift)){
                    requestTimeSlot.employeeId = employeeMapping[shift.employeeId];
                }
                //if shift was manually pinned, is already published, wasnt selected for planning or is from previous month (rosterConfig.month starts with 1) then pin it
                if(shift.pinned || shift.published || !this.selectedShifts.includes(shift.id) || isPreviousMonthShift){
                    
                    requestTimeSlot.locked = true;
                }
                if(shiftSkillMap[key] != undefined){
                    for (j = 0; j < shiftSkillMap[key].length; j++) { 
                        let shiftSkill = shiftSkillMap[key][j];
                        
                        if(skillMapping[shiftSkill.skillId] != null){ //check if skill id was ever put in skillMapping and therefore has request id
                            if(shiftSkill.required){
                                requestTimeSlot.requiredSkills[skillMapping[shiftSkill.skillId]] = shiftSkill.minValue;
                                requestTimeSlot.requiredSkills[-1*skillMapping[shiftSkill.skillId]] = shiftSkill.maxValue+1;
                            } else {
                                requestTimeSlot.optionalSkills.push(skillMapping[shiftSkill.skillId])
                            }
                        
                        } 
                    }
                }
                
                if(requestShiftMap[""+workDayIndex] === undefined){
                    requestShiftMap[""+workDayIndex] = {}
                }
                requestShiftMap[""+workDayIndex][requestkey] = requestTimeSlot;
                customEntityMapping.shiftMapping[requestkey] = {originalId: shift.id, hash: shift.hash};
                shiftRequestId++;
            }
        }
        
        //map for storing availabilities per dayIndex per employee, need to check during preference loop whether there is a preference on same day that overwrites availabilities
        //if yes -> need to delete the entry
        let tempAvailabilityMap = {}
        for (key in employeeAvailabilityMap) {
            if (employeeAvailabilityMap.hasOwnProperty(key)) {
                for (j = 0; j < employeeAvailabilityMap[key].length; j++) { 
                    let employeeAvailability = employeeAvailabilityMap[key][j];
                    if(employeeAvailability.spotId == null || spotMapping[employeeAvailability.spotId] != undefined){
                        let tempRosterStart = this.$helpers.getMomentFromValuesUTC(this.fullWeekPlanFrom.year(), this.fullWeekPlanFrom.month(), this.fullWeekPlanFrom.date(), 0, 0);
                        let tempRosterEnd = this.$helpers.getMomentFromValuesUTC(this.fullWeekPlanTo.year(), this.fullWeekPlanTo.month(), this.fullWeekPlanTo.date(), 0, 0);
                        let availStartDate = this.$helpers.getMomentFromStringUTC(employeeAvailability.from,'HH:mmZ').year(this.fullWeekPlanFrom.year()).month(this.fullWeekPlanFrom.month()).date(this.fullWeekPlanFrom.date());
                        let availEndDate = this.$helpers.getMomentFromStringUTC(employeeAvailability.to,'HH:mmZ').year(this.fullWeekPlanFrom.year()).month(this.fullWeekPlanFrom.month()).date(this.fullWeekPlanFrom.date());
                        
                        if(availEndDate.diff(availStartDate) <= 0){
                            availEndDate.add(24,'hours');
                        }
                            
                        while(tempRosterEnd.diff(tempRosterStart, 'minutes') > 0){
                            let weekDay = tempRosterStart.isoWeekday();
                            
                            let workDayIndex = this.calculateWorkDayIndex(tempRosterStart);
                            
                            if(employeeAvailability.weekDays.includes(weekDay)
                                && employeeAvailability.employeeId != null 
                                && employeeMapping[employeeAvailability.employeeId] != undefined){
                                let state = employeeAvailability.state;
                                let stateStr = "";
                                if(state == 1){ stateStr = "UNAVAILABLE";}
                                if(state == 2){ stateStr = "AVAILABLE";}
                                if(state == 3){ stateStr = "UNDESIRED";}
                                if(state == 4){ stateStr = "DESIRED";}
                                
                            
                                let requestAvailability = {
                                                    id: -1, // set id later after preference loop
                                                    fromH: availStartDate.hours(),
                                                    fromM: availStartDate.minutes(),
                                                    toH: availEndDate.hours(),
                                                    toM: availEndDate.minutes(),
                                                    employeeId: employeeMapping[employeeAvailability.employeeId],
                                                    state: stateStr,
                                                    exclusive: employeeAvailability.exclusive, 
                                                    factor: employeeAvailability.factor}
                                if(employeeAvailability.spotId != null && spotMapping[employeeAvailability.spotId] != undefined){
                                    requestAvailability.spotId = spotMapping[employeeAvailability.spotId];
                                }
                                
                                
                                if(tempAvailabilityMap[workDayIndex] === undefined){
                                    tempAvailabilityMap[workDayIndex] = {};
                                }
                                if(tempAvailabilityMap[workDayIndex][requestAvailability.employeeId] === undefined){
                                    tempAvailabilityMap[workDayIndex][requestAvailability.employeeId] = []
                                }
                                tempAvailabilityMap[workDayIndex][requestAvailability.employeeId].push(requestAvailability);
                                
                            }
                            tempRosterStart.add(24,'hours');
                            //availStartDate.setUTCHours(availStartDate.getUTCHours() + 24);
                            //availEndDate.setUTCHours(availEndDate.getUTCHours() + 24);
                        }
                    }
                }
            }
        }

        
        for (key in employeePreferenceMap) {
            
            if (employeePreferenceMap.hasOwnProperty(key)) {
                for (j = 0; j < employeePreferenceMap[key].length; j++) { 
                    let pref = employeePreferenceMap[key][j];
                    
                    if((pref.spotId == null || spotMapping[pref.spotId] != undefined)
                        && pref.employeeId != null && employeeMapping[pref.employeeId] != undefined){
                        
                        let prefStartDate = this.$helpers.getMomentFromStringUTC(pref.from);
                        let prefEndDate = this.$helpers.getMomentFromStringUTC(pref.to);

                        let state = pref.state;
                        let stateStr = "";
                        if(state == 1){ stateStr = "UNAVAILABLE";}
                        if(state == 2){ stateStr = "AVAILABLE";}
                        if(state == 3){ stateStr = "UNDESIRED";}
                        if(state == 4){ stateStr = "DESIRED";}
                        
                        let requestPreference = {
                                            id: preferenceRequestId,
                                            fromH: prefStartDate.hours(),
                                            fromM: prefStartDate.minutes(),
                                            toH: prefEndDate.hours(),
                                            toM: prefEndDate.minutes(), 
                                            state: stateStr,
                                            employeeId: employeeMapping[pref.employeeId],
                                            exclusive: pref.exclusive, 
                                            factor: pref.factor}
                        if(pref.spotId != null && spotMapping[pref.spotId] != undefined){
                            requestPreference.spotId = spotMapping[pref.spotId];
                        }
                        if(pref.workValue != null && pref.state == 1){
                            requestPreference.workValue = pref.workValue;
                            requestPreference.workDayF = true;
                            requestPreference.dayTimeF = true;
                            requestPreference.weekTimeF = true;
                            requestPreference.monthTimeF = true;
                        }
                        
                        //loop through days
                        while(prefEndDate.diff(prefStartDate,'minutes') > 1440){ 
                            let workDayIndex = this.calculateWorkDayIndex(prefStartDate);
                            
                            if(pref.overrideContract){ //if preference overrides availabilities, delete all availabilties for that day for that employee
                                if(tempAvailabilityMap[workDayIndex] != undefined && tempAvailabilityMap[workDayIndex][requestPreference.employeeId] != undefined){
                                    delete tempAvailabilityMap[workDayIndex][requestPreference.employeeId];
                                }
                                //in case that the preference goes over midnight we need to delete the availabilities of next day too
                                let tprefEndDate = this.$helpers.getMomentFromValuesUTC(prefStartDate.year(), prefStartDate.month(), prefStartDate.date(), prefEndDate.hours(), prefEndDate.minutes());
                        
                                if(tprefEndDate.diff(prefStartDate, 'minutes') <= 0){
                                    if(tempAvailabilityMap[workDayIndex+1] != undefined && tempAvailabilityMap[workDayIndex+1][requestPreference.employeeId] != undefined){
                                        delete tempAvailabilityMap[workDayIndex+1][requestPreference.employeeId];
                                    } 
                                }
                            }
                            if(requestPreferenceMap[""+workDayIndex] === undefined){
                                requestPreferenceMap[""+workDayIndex] = []
                            }
                            requestPreferenceMap[""+workDayIndex].push(Object.assign({}, requestPreference));
                            prefStartDate.add(24,'hours');
                            preferenceRequestId++;
                            requestPreference.id = preferenceRequestId;
                            
                        }
                        if(prefEndDate.diff(prefStartDate,'minutes') > 0){
                            let workDayIndex = this.calculateWorkDayIndex(prefStartDate);
                            if(pref.overrideContract){ //if preference overrides availabilities, delete all availabilties for that day for that employee
                                if(tempAvailabilityMap[workDayIndex] != undefined && tempAvailabilityMap[workDayIndex][requestPreference.employeeId] != undefined){
                                    delete tempAvailabilityMap[workDayIndex][requestPreference.employeeId];
                                }
                                //in case that the preference goes over midnight we need to delete the availabilities of next day too
                                let tprefEndDate = this.$helpers.getMomentFromValuesUTC(prefStartDate.year(), prefStartDate.month(), prefStartDate.date(), prefEndDate.hours(), prefEndDate.minutes());
                        
                                 if(tprefEndDate.diff(prefStartDate, 'minutes') <= 0){
                                    if(tempAvailabilityMap[workDayIndex+1] != undefined && tempAvailabilityMap[workDayIndex+1][requestPreference.employeeId] != undefined){
                                        delete tempAvailabilityMap[workDayIndex+1][requestPreference.employeeId];
                                    } 
                                }
                            }
                            if(requestPreferenceMap[""+workDayIndex] === undefined){
                                requestPreferenceMap[""+workDayIndex] = []
                            }
                            
                            requestPreferenceMap[""+workDayIndex].push(Object.assign({}, requestPreference));
                            preferenceRequestId++;
                        }
                       
                        
                    }
                    
                }
            }
        }

        //iterate over remaining availabilities and add them to the request
        for(key in tempAvailabilityMap){
            if (tempAvailabilityMap.hasOwnProperty(key)){
                let key2 = null;
                for(key2 in tempAvailabilityMap[key]){
                    if (tempAvailabilityMap[key].hasOwnProperty(key2)){
                        let availabilities = tempAvailabilityMap[key][key2];
                        for(j = 0; j < availabilities.length; j++){
                            preferenceRequestId++;
                            let requestAvailability = availabilities[j];
                            requestAvailability.id = preferenceRequestId;
                            if(requestPreferenceMap[""+key] === undefined){
                                requestPreferenceMap[""+key] = []
                            }
                            
                            requestPreferenceMap[""+key].push(Object.assign({}, requestAvailability));
                        }
                    }
                }

            }
        }

        let planningConfiguration = {
            maxRunTime: this.planRunTime*60,
            unimprovedMaxTime: Math.ceil(shiftRequestId/500)*60,
            cores: 0,
        }
        
       
        if(!this.$helpers.isBlank(this.ruleProfile)){
            
            this.rosterConfiguration.rulesSoftScoreLevels = this.ruleProfileMap[this.ruleProfile].rulesSoftScoreLevels;
            
        }
        customEntityMapping['hp'] = this.hp;
        if(this.hp){
            planningConfiguration.cores = 3;
        }
        let payload = {
            storeId: ""+this.$store.state.storeId,
            ruleProfileId: this.ruleProfile,
            rosterConfiguration: this.rosterConfiguration,
            skillMap: requestSkillMap,
            spotMap: requestSpotMap,
            employeeTypeMap: requestTypeMap,
            employeeMap: requestEmployeeMap,
            timeSlotDefinitions: requestShiftMap,
            employeePreferences: requestPreferenceMap,
            customEntityMapping: customEntityMapping,
            planningConfiguration: planningConfiguration
        };
        console.log(JSON.stringify(payload));
        return payload;
        

    },
    checkMissingContractIntervals(employeeIds){
        for(let i = 0; i < employeeIds.length; i++){
            let id = employeeIds[i];
            if(this.employeeContractMap[id] != null && this.employeeContractMap[id].length > 0){
                let filteredContracts = this.employeeContractMap[id].filter(entry => this.$helpers.getMomentFromStringUTC(entry.from).isSameOrBefore(this.fullWeekPlanTo) && (entry.to == null || this.$helpers.getMomentFromStringUTC(entry.to).isSameOrAfter(this.fullWeekPlanFrom)));
                
                if(filteredContracts.length > 0){
                    let prevTo = this.fullWeekPlanFrom;
                    for(let j = 0; j < filteredContracts.length; j++){
                        let current = filteredContracts[j];
                        let currentFrom = this.$helpers.getMomentFromStringUTC(current.from);
                        if(currentFrom.diff(prevTo, 'minutes') > 0){
                            this.addContractUnavailablePreference(id, prevTo, currentFrom);
                        }
                        let currentTo = null;
                        if (current.to != null){
                            currentTo = this.$helpers.getMomentFromStringUTC(current.to)
                        }
                        //check if last element in array has a to value that is smaller than fullWeekPlanTo
                        if(j == filteredContracts.length -1 && currentTo != null && this.fullWeekPlanTo.diff(currentTo, 'minutes') > 0){
                            this.addContractUnavailablePreference(id, currentTo, this.fullWeekPlanTo);

                        }
                        prevTo = currentTo;
                    }
                } else {
                    //no contract where to is larger than fullWeekPlanFrom => cannot be assigned for whole month
                    this.addContractUnavailablePreference(id, this.fullWeekPlanFrom, this.fullWeekPlanTo)
                    
                   
                }
                
            }
        }
    },
    addContractUnavailablePreference(employeeId, from, to){
        let tEmployeePreference = {
            id: this.generateUUID(),
            employeeId: employeeId,
            from: from.format(),
            to: to.format(),
            state: 1,
            type: 5,
            workValue: 0,
            exclusive: true,
            deleted: false,
            approved: true,
            overrideContratc: true,
            factor: 1,
            storeId: this.$store.state.storeId
        }
        let employee = "";
        if(employeeId != null){
            employee = this.employeeMap[employeeId].firstName+" "+this.employeeMap[employeeId].lastName;
        }
        let tOption = { id: tEmployeePreference.id, state: tEmployeePreference.state, type: tEmployeePreference.type, workValue: tEmployeePreference.workValue,
                        from: from.format("DD.MM.YYYY HH:mm"), to: to.format("DD.MM.YYYY HH:mm"), 
                         employee: employee, spot: "", type: tEmployeePreference.type, value: tEmployeePreference, checked: true }
        this.employeePreferenceOptions.push(tOption);
    },
    generateUUID: function(){
        //https://jcward.com/UUID.js
        let lut = []; for (var i=0; i<256; i++) { lut[i] = (i<16?'0':'')+(i).toString(16); }
        let d0 = Math.random()*0xffffffff|0;
        let d1 = Math.random()*0xffffffff|0;
        let d2 = Math.random()*0xffffffff|0;
        let d3 = Math.random()*0xffffffff|0;
            return lut[d0&0xff]+lut[d0>>8&0xff]+lut[d0>>16&0xff]+lut[d0>>24&0xff]+'-'+
            lut[d1&0xff]+lut[d1>>8&0xff]+'-'+lut[d1>>16&0x0f|0x40]+lut[d1>>24&0xff]+'-'+
            lut[d2&0x3f|0x80]+lut[d2>>8&0xff]+'-'+lut[d2>>16&0xff]+lut[d2>>24&0xff]+
            lut[d3&0xff]+lut[d3>>8&0xff]+lut[d3>>16&0xff]+lut[d3>>24&0xff];
    },
    loadUIData: function(){
        let url = '/api/semi/uidata';
        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).catch(error => 
            Promise.reject({msg: "Fehler beim Laden der UI Daten"})
        );
    },
    loadRuleProfiles : function() {
       
        let url = '/api/sec/ruleprofile';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruleprofile');
            

         return this.axios({
             method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).catch(error => 
            Promise.reject({msg: "Fehler beim Laden der Regel Profile"})
        )
         
    },
    loadSpots : function() {
        let url = '/api/sec/spot';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');
            
        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).catch(error => 
            Promise.reject({msg: "Fehler beim Laden der Positionen"})
        )
    },
    loadShiftsAnySpotAnyEmployee : function(spotPayload, employeePayload) {
        if(this.$helpers.isBlank(spotPayload.ids) || spotPayload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/planshift/any/spot/employee';
            let params = {
                storeId: this.$store.state.storeId,
                from: this.fullWeekPlanFrom.format(),
                to: this.fullWeekPlanTo.format()
            }
           
            
            let payload = {
                spotIds: spotPayload,
                employeeIds: employeePayload
            };
            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Schichten"})
            )
        } 		
    },
    loadEmployeesAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employee/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/any');
            url = this.$helpers.appendParam("hastype", true, url, '/api/sec/employee/any');

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter"})
            )
        } 			
    },
    loadEmployeeContractsAnyEmployee : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeecontract/any/employee';
            let params = {
                storeId: this.$store.state.storeId,
            }
            
            
            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter Verträge"})
            )
        } 		
    },
    loadShiftSkillsAnyShift : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/shiftskillrequirement/any/shift';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftskillrequirement/any/shift');
            
            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Schicht Skills"})
            )
        } 		
    },
    loadSkills : function(payload) {
        
        let url = '/api/sec/skill';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/skill');
            

        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).catch(error => 
            Promise.reject({msg: "Fehler beim Laden der Skills"})
        )
        		 
    },
    loadEmployeesAnySkill : function(payload) {
      if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employee/any/skill';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/any/skill');
            url = this.$helpers.appendParam("hastype", true, url, '/api/sec/employee/any/skill');

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter"})
            )
        } 			
    },
    loadEmployeeSkillsAnyEmployee : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeeskill/any/employee';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeskill/any/employee');
            
            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter Skills"})
            )
        } 		
    },
    loadEmployeeRulesAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeerules/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules/any');
            
            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter Regeln"})
            )
        } 		
    },
    loadEmployeeTypeAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeetype/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetype/any');
            
            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter Typen"})
            )
        } 		
    },
    loadEmployeeAvailabilityAnyEmployee : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeeavailability/any/employee';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeavailability/any/employee');
            
            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter Verfügbarkeiten"})
            )
        } 		
    },
    loadEmployeePreferenceAnyEmployee : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employeepreference/any/employee';
            let params = {
                storeId: this.$store.state.storeId,
                from: this.fullWeekPlanFrom.format(),
                to: this.fullWeekPlanTo.format(),
                approved: true
            }
            
            
            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter Wünsche & Urlaube"})
            )
        } 		
    },
    updateUIData: function(data){
        this.uiData = data;
        let stateMap =  {};
        let typeMap = {};
        for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
            let employeeAvailabilityState = data.employeeAvailabilityStates[i];
            stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;   
        }
         for(let i = 0; i < data.employeeAvailabilityTypes.length; i++){
            let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
            typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;   
        }
        this.employeeAvailabilityStateMap = stateMap;
        this.employeeAvailabilityTypeMap = typeMap;
    },
    submitRosterRequest : function(payload) {
       
        let url = '/api/sec/employeeroster';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeroster');

        return this.axios({
             method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).catch(error => 
                Promise.reject({msg: "Fehler beim Absenden des Plans"})
        )
        			
    },
    calculateWorkDayIndex: function(EndDate){
        let fixedEndDate = EndDate.clone().hours(0).minutes(0).seconds(0).milliseconds(0);
        let StartDate = this.$helpers.getMomentFromValuesUTC(this.rosterConfiguration.year, this.rosterConfiguration.month-1, 1);
        let nDays = fixedEndDate.diff(StartDate) / 86400000;
        return nDays+1; //workDay Index starts with 1
    },
    extractDate: function(str){
        if(!this.$helpers.isBlank(str)) {
            let split = str.split("T");
            return split[0];
        } else {
            return null;
        }
    },
    extractTime: function(str){
        if(!this.$helpers.isBlank(str)) {
            let split1 = str.split("T");
            let split2 = split1[1].split(":")
            return split2[0]+":"+split2[1];
        } else {
            return null;
        } 
    },
    getMinuteDiff: function(from, to) {
        var diff =(to.getTime() - from.getTime()) / 1000;
        diff /= 60;
        return Math.round(diff);
    },
    getMinuteDiffAbs: function(from, to) {
        var diff =(to.getTime() - from.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    },

  },
}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>

</style>
